export default "__VITE_ASSET__JAxyYWJa__"